import React, { useEffect, useMemo, useState } from "react";
// import ExternalInvoiceReportHeader from "./ExternalInvoiceReportHeader/ExternalInvoiceReportHeader";
import {
  getInoviceOrderItem,
  getInvoiceColumns,
  getInvoiceColumnValue,
  getInvoicePrint,
  getInvoiceReportData,
} from "../../redux/actions/invoiceReport.action";
import { useDispatch, useSelector } from "react-redux";
import { ReadCookie } from "../../utils/readCookie";
import { useLocation } from "react-router-dom";
import Loader from "react-loader-spinner";
import "./ExternalInvoiceReport.css";
import { Button, Card } from "antd";
import moment from "moment";
import { TabTitle } from "../../utils/GeneralFunction";
import { searchExternalInvoice } from "../../redux/actions/searchExternalInvoice.action";
import ExternalInvoiceReportHeader from "./ExternalInvoiceReportHeader/ExternalInvoiceReportHeader";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const ExternalInvoiceReport = () => {
  TabTitle("External-Invoice-Report");
  const dispatch = useDispatch();
  const menuId = ReadCookie("menuId");
  const token = ReadCookie("token");
  const [loader, setLoader] = useState(true);
  const [reportData, setReportData] = useState([]);
  const [reportColData, setReportColData] = useState([]);
  const [reportSummary, setReportSummary] = useState([]);
  const [reportColDataLength, setReportColDataLength] = useState(0);
  const { invoicePrint, invoiceColumns, invoiceColumnsValues } = useSelector(
    (state) => state
  );
  console.log(reportColData, "reportColData");

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let external_invoice_no = query.get("external_invoice_no");
  console.log({ external_invoice_no });

  useEffect(() => {
    setLoader(true);
    dispatch(searchExternalInvoice(token, external_invoice_no))
      .then((res) => {
        if (res?.payload?.data) {
          setReportData(res?.payload?.data);
          setReportColData(res?.payload?.columns);
          setReportSummary(res?.payload?.summary);
          setReportColDataLength(res?.payload?.columns.length);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  }, [dispatch, menuId, token]);
  console.log({ reportData });
  const footerData = reportData.length > 0 && reportData;
  let groupValues =
    reportData.length > 0 &&
    reportData.reduce(function (r, a) {
      r[a.gender_category_id] = r[a.gender_category_id] || [];
      r[a.gender_category_id].push(a);
      return r;
    }, Object.create(null));

  const groupedColumnValue = groupValues && Object.values(groupValues);
  const myData = useMemo(() => {
    return (
      reportData.length > 0 &&
      reportData.map((it, i) => {
        return {
          column: it,
          detail: groupedColumnValue && groupedColumnValue[i],
        };
      })
    );
  }, [groupedColumnValue]);

  console.log("myData", myData);

  const handlePrint = () => {
    const css =
      "@page { size: A4 portrait; margin-top: 25px; margin-bottom: 25px; margin-right: 0px; padding: 0px}";
    const style = document.createElement("style");
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };

  const sizeLookup = {};

  reportColData.forEach((col) => {
    Object.keys(col).forEach((key) => {
      if (key.startsWith("hq") && col[key]) {
        sizeLookup[`${col.gender_category_id}_${col[key]}`] = true;
      }
    });
  });

  const hqKeys =
    reportColData.length > 0
      ? Object.keys(reportColData[0]).filter((key) => key.startsWith("hq"))
      : [];

  const quantityLookup = {};
  reportColData.forEach((val) => {
    hqKeys.forEach((hqKey) => {
      const key = `${val.gender_category_id}-${hqKey}-${val[hqKey]}`;
      quantityLookup[key] = val.quantity;
    });
  });

  const groupedReportData = React.useMemo(() => {
    const map = {};

    reportData.forEach((item) => {
      const key = `${item.invoice_header_no}_${item.item_code}`;

      if (!map[key]) {
        map[key] = {
          ...item,
          sizeMap: {}, // yahan sizes ki quantity store hogi
        };
      }

      // sku_size → quantity mapping
      map[key].sizeMap[item.sku_size] =
        (map[key].sizeMap[item.sku_size] || 0) + Number(item.quantity);
    });

    return Object.values(map);
  }, [reportData]);

  console.log(groupedReportData, "groupedReportData");

  return (
    <div>
      {loader ? (
        <div className="loaderDiv">
          <Loader type="Grid" color="#212121" height={40} width={40} />
        </div>
      ) : reportData.length == 0 ? (
        <div className="h-full d-flex align-items-center">
          <div className="no-Data w-100">
            <h1>No Data</h1>
          </div>
          {/* <Link
            style={{ textDecoration: "none" }}
            target="_blank"
            rel="noopener noreferrer"
            to={{
              pathname: `/external-invoice-report`,
              // search: `?external_invoice_no=${form.getFieldValue(
              //   "external_invoice_no"
              // )}`,
            }}
          >
            Go Back
          </Link> */}
        </div>
      ) : (
        <div
          className="sales_report_view"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <table style={{ display: "block" }}>
            <thead>
              <tr>
                <td className="footer_invoice">
                  <div style={{ background: "white", width: "62%", zIndex: 2 }}>
                    <ExternalInvoiceReportHeader data={reportData} />
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  // background: "blue",
                  padding: 0,
                  margin: 0,
                  verticalAlign: "top",
                  display: "block", // ⭐ MOST IMPORTANT
                }}
              >
                <td
                  style={{
                    // background: "red",
                    padding: 0,
                    margin: 0,
                    verticalAlign: "top",
                    display: "block", // ⭐ MOST IMPORTANT
                  }}
                >
                  <div className="content-block2 external-invoice-report-body">
                    <div className="sales-report-Table-data">
                      <div>
                        <table
                          className="sales-report-table"
                          style={{ width: "99%" }}
                        >
                          <tbody>
                            {reportColData.length > 0 &&
                              reportColData.map((colRows, index) => (
                                <tr>
                                  {index === 0 && (
                                    <>
                                      {/* <td rowSpan={reportColDataLength}>S #</td> */}
                                      <td
                                      className="text-center pl-0"
                                        style={{
                                          width: "60px",
                                        }}
                                        rowSpan={reportColDataLength}
                                      >
                                        Invoice
                                      </td>
                                      <td
                                      className="text-center pl-0"
                                        style={{
                                          width: "100px",
                                        }}
                                        rowSpan={reportColDataLength}
                                      >
                                        SKU
                                      </td>
                                      <td
                                      className="text-center pl-0"
                                        style={{
                                          width: "100px",
                                        }}
                                        rowSpan={reportColDataLength}
                                      >
                                        PO #
                                      </td>
                                      <td
                                      className="text-center pl-0"
                                        style={{
                                          width: "100px",
                                          // width:"max-content",
                                          whiteSpace: "nowrap",
                                        }}
                                        rowSpan={reportColDataLength}
                                      >
                                        Style
                                      </td>
                                      <td
                                      className="text-center pl-0"
                                        style={{
                                          width: "120px",
                                          // width:"max-content",
                                          whiteSpace: "nowrap",
                                        }}
                                        rowSpan={reportColDataLength}
                                      >
                                        Wash
                                      </td>
                                    </>
                                  )}
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq23 && colRows.hq23}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq24 && colRows.hq24}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq25 && colRows.hq25}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq26 && colRows.hq26}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq27 && colRows.hq27}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq28 && colRows.hq28}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq29 && colRows.hq29}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq30 && colRows.hq30}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq31 && colRows.hq31}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq32 && colRows.hq32}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq33 && colRows.hq33}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq34 && colRows.hq34}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq35 && colRows.hq35}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq36 && colRows.hq36}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq37 && colRows.hq37}
                                  </td>
                                  <td className="external_invoices_table_col font_weight text-center pl-0">
                                    {colRows.hq38 && colRows.hq38}
                                  </td>
                                  {index === 0 && (
                                    <>
                                      <td
                                        rowSpan={reportColDataLength}
                                        className="font_weight text-center pl-0"
                                        style={{
                                          width: "40px",
                                        }}
                                      >
                                        Qty
                                      </td>
                                      <td
                                        rowSpan={reportColDataLength}
                                        className="font_weight"
                                        style={{
                                          width: "50px",
                                        }}
                                      >
                                        Rate
                                      </td>
                                      <td
                                        rowSpan={reportColDataLength}
                                        className="font_weight"
                                        style={{
                                          width: "70px",
                                        }}
                                      >
                                        Amount
                                      </td>
                                    </>
                                  )}
                                </tr>
                              ))}

                            {groupedReportData.length > 0 &&
                              groupedReportData.map((it, index) => (
                                <tr key={index}>
                                  {/* <td>{index+1}</td> */}
                                  <td className="text-center pl-0">{it.invoice_header_no}</td>
                                  <td className="text-center pl-0">{it.item_code}</td>
                                  <td className="text-center pl-0">{it.po_number}</td>
                                  <td className="text-center pl-0">{it.style_name}</td>
                                  <td className="text-center pl-0">{it.wash_name}</td>

                                  {hqKeys.map((hqKey) => {
                                    const sizeMatched = reportColData?.some(
                                      (val) =>
                                        val.gender_category_id.includes(
                                          it.gender_category_id
                                        ) &&
                                        String(val[hqKey]) ===
                                          String(
                                            Object.keys(it.sizeMap).find(
                                              (size) => size === val[hqKey]
                                            )
                                          )
                                    );

                                    const qty = reportColData?.find(
                                      (val) =>
                                        val.gender_category_id.includes(
                                          it.gender_category_id
                                        ) && it.sizeMap[val[hqKey]]
                                    )
                                      ? it.sizeMap[
                                          reportColData.find((val) =>
                                            val.gender_category_id.includes(
                                              it.gender_category_id
                                            )
                                          )[hqKey]
                                        ]
                                      : 0;

                                    return (
                                      <td
                                        key={hqKey}
                                        className="text-center pl-0"
                                      >
                                        {qty || 0}
                                      </td>
                                    );
                                  })}

                                  <td className="text-center pl-0">
                                    {it.item_quantity}
                                  </td>
                                  <td>
                                    $ {it.rate}
                                  </td>
                                  <td>$ {it.amount}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <table
                    className="invoice-report-table-total external-invoice-report-total"
                    style={{ fontSize: "10px" }}
                  >
                    <tbody>
                      <tr className="font_weight">
                        <td
                          colSpan={3}
                          style={{
                            width: "100px",
                            textAlign: "left",
                            paddingLeft: "10px",
                          }}
                          className="font_weight total_cell"
                        >
                          Total Quantity
                        </td>

                        <td className="total_amount" style={{ width: "70px" }}>
                          {reportSummary &&
                            reportSummary.reduce((acc, val) => {
                              return acc + val.sum_quantity;
                            }, 0)}
                        </td>
                      </tr>
                      <tr className="font_weight">
                        <td
                          colSpan={3}
                          style={{
                            width: "100px",
                            textAlign: "left",
                            paddingLeft: "10px",
                          }}
                          className="font_weight total_cell"
                        >
                          Gross Total
                        </td>

                        <td className="total_amount" style={{ width: "70px" }}>
                          ${" "}
                          {reportSummary &&
                            reportSummary
                              .reduce((acc, val) => {
                                return acc + parseFloat(val.sum_gross_amount);
                              }, 0)
                              .toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            width: "100px",
                            textAlign: "left",
                            paddingLeft: "10px",
                            fontSize: "12px",
                          }}
                          className="font_weight"
                        >
                          LESS
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={3}
                          className="font_weight"
                          style={{
                            width: "100px",
                            textAlign: "left",
                            paddingLeft: "10px",
                          }}
                        >
                          Disc Amount
                        </td>

                        <td>
                          ${" "}
                          {reportSummary &&
                            reportSummary
                              .reduce((acc, val) => {
                                return acc + parseFloat(val.discount);
                              }, 0)
                              .toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            width: "100px",
                            textAlign: "left",
                            paddingLeft: "10px",
                            fontSize: "12px",
                          }}
                          className="font_weight"
                        >
                          ADD
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={3}
                          className="font_weight"
                          style={{
                            width: "100px",
                            textAlign: "left",
                            paddingLeft: "10px",
                          }}
                        >
                          Sales Tax
                        </td>
                        <td>
                          ${" "}
                          {reportSummary &&
                            reportSummary
                              .reduce((acc, val) => {
                                return acc + parseFloat(val.tax_percent);
                              }, 0)
                              .toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={3}
                          className="font_weight"
                          style={{
                            width: "100px",
                            textAlign: "left",
                            paddingLeft: "10px",
                          }}
                        >
                          Freight
                        </td>
                        <td>
                          ${" "}
                          {reportSummary &&
                            Number(
                              reportSummary.reduce((acc, val) => {
                                return acc + parseFloat(val.shipping_cost);
                              }, 0)
                            ).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={3}
                          className="font_weight"
                          style={{
                            width: "100px",
                            textAlign: "left",
                            paddingLeft: "10px",
                          }}
                        >
                          Surcharge Amount
                        </td>
                        <td>
                          ${" "}
                          {reportSummary &&
                            Number(
                              reportSummary.reduce((acc, val) => {
                                return acc + parseFloat(val.surcharge_amount);
                              }, 0)
                            ).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={3}
                          className="font_weight"
                          style={{
                            width: "100px",
                            textAlign: "left",
                            paddingLeft: "10px",
                          }}
                        >
                          C. C. Charges
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <td
                          colSpan={3}
                          className="font_weight"
                          style={{
                            width: "100px",
                            textAlign: "left",
                            paddingLeft: "10px",
                          }}
                        >
                          Net Amount
                        </td>
                        <td>
                          ${" "}
                          {reportSummary &&
                            reportSummary
                              .reduce((acc, val) => {
                                return acc + parseFloat(val.net_amount);
                              }, 0)
                              .toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {footerData && footerData[0].factor_id == 1 ? (
                    <>
                      <div
                        className="no-print-break print-footer"
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                          marginTop: "10px",
                          width: "98%",
                          baground: "blue",
                          pageBreakInside: "avoid",
                          pageBreakAfter: "avoid",
                        }}
                      >
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #e5e5e5",
                          }}
                        >
                          <div style={{ padding: "10px 15px" }}>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "9px",
                              }}
                            >
                              This Invoice has been sold or assigned to
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "9px",
                              }}
                            >
                              THE CIT GROUP / COMMERCIAL SERVICES INC.
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "9px",
                              }}
                            >
                              P.O BOX 1036 , CHARLOTTE,NC 28201-1036
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "9px",
                              }}
                            >
                              to whom the account has been assigned solely for
                              collection
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "9px",
                              }}
                            >
                              and to whom notice must be given of any
                              merchandise
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "9px",
                              }}
                            >
                              returns or claims.Payment made to any other party
                              does
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "9px",
                              }}
                            >
                              not constitute valid payment of this invoice.
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #e5e5e5",
                          }}
                        >
                          <div style={{ padding: "10px 15px" }}>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "12px",
                                textDecoration: "underline",
                              }}
                            >
                              Terms & Conditions
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                fontSize: "9px",
                              }}
                            >
                              1) No Return of goods after 45 days of shipment.
                              <br />
                              2) Damaged goods must be returned within 10 days
                              of shipment.
                              <br />
                              3) No Returns will be accepted without RA#.
                              <br />
                              4) Payments must be received within due date.
                              <br />
                              5) All Overdue invoices will be charged @1.8% per
                              month.
                              <br />
                              6) No Return allowed on sale item.
                              <br />
                              7) Returns without an advance shipping notice
                              (including tracking#) and an approved RA# will not
                              be processed.
                              <br />
                              8) A 5% deduction will be applied to any returned
                              unit that is missing the waist tag.
                              <br />
                              9) RA credits will not be issued for merchandise
                              that is worn, stained, or damaged.
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : footerData[0].term === "WIRE TRANSFER" ||
                    footerData[0].term === "CONSIGNMENT" ||
                    footerData[0].term === "PRE-PAYMENT" ||
                    footerData[0].factor_id == 2 ? (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                          marginTop: "10px",
                          width: "98%",
                        }}
                      >
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #e5e5e5",
                          }}
                        >
                          <div style={{ padding: "10px 15px" }}>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "9px",
                              }}
                            >
                              Remit Payment To
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "9px",
                              }}
                            >
                              US Customer Send Payment To:
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "9px",
                              }}
                            >
                              DL1961 Premium Denim Inc.
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "9px",
                              }}
                            >
                              121 Varick Street, 4th Floor
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "9px",
                              }}
                            >
                              NEW YORK ,NY 10013, USA
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #e5e5e5",
                          }}
                        >
                          <div style={{ padding: "10px 15px" }}>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "10px",
                                textDecoration: "underline",
                              }}
                            >
                              Customer Wire Payment To:
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                fontSize: "9px",
                              }}
                            >
                              JPMorgan Chase Bank,NA. <br />
                              Address : 601 8thAve,New York,NY 10018
                              <br />
                              Phone : (212) 695-9164
                              <br />
                              Account Number : 218335361
                              <br />
                              Routing Number : 021000021
                              <br />
                              Swift Code : CHASUS33
                              <br />
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #e5e5e5",
                            width: '300px'
                          }}
                        >
                          <div style={{ padding: "10px 15px" }}>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "10px",
                                textDecoration: "underline",
                              }}
                            >
                              Terms & Conditions
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                fontSize: "9px",
                              }}
                            >
                              1) No Return of goods after 15 days of shipment.
                              <br />
                              2) Damaged goods must be returned within 10 days
                              of shipment.
                              <br />
                              3) No Returns will be accepted without RA #.
                              <br />
                              4) Returns without an advance shipping notice
                              (including tracking#) and an approved RA# will not
                              be processed.
                              <br />
                              5) A 5% deduction will be applied to any returned
                              unit that is missing the waist tag.
                              <br />
                              6) RA credits will not be issued for merchandise
                              that is worn, stained, or damaged.
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                          marginTop: "10px",
                          width: "98%",
                        }}
                      >
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #e5e5e5",
                          }}
                        >
                          <div style={{ padding: "10px 15px" }}>
                            <p
                              style={{
                                marginBottom: 0,
                                textAlign: "center",
                                fontSize: "12px",
                                textDecoration: "underline",
                              }}
                            >
                              Terms & Conditions
                            </p>
                            <p
                              style={{
                                marginBottom: 0,
                                fontSize: "9px",
                              }}
                            >
                              1) No Return of goods after 15 days of shipment.
                              <br />
                              2) Damaged goods must be returned within 10 days
                              of shipment.
                              <br />
                              3) No Returns will be accepted without RA #.
                              <br />
                              4) Returns without an advance shipping notice
                              (including tracking#) and an approved RA# will not
                              be processed.
                              <br />
                              5) A 5% deduction will be applied to any returned
                              unit that is missing the waist tag.
                              <br />
                              6) RA credits will not be issued for merchandise
                              that is worn, stained, or damaged.
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </td>
              </tr>
            </tbody>
            {}
            {/* {footerData && footerData[0].term === "CREDIT CARD" ? (
              <tfoot>
                <tr>
                  <td className="footer2_invoice external_invoice_footer">
                    <div className="sales-report-footer">
                      <div className="order_report_footer">
                        <div style={{ float: "left", fontSize: "14px" }}>
                          Due Date:{" "}
                          {footerData &&
                            moment(footerData[0].due_date).format("MM/DD/YYYY")}
                        </div>
                        <br />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Card style={{ width: "390px" }}>
                            <p
                              className="footer_order_p"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                textDecoration: "underline",
                              }}
                            >
                              Terms & Conditions
                            </p>
                            <p className="footer_order_p">
                              1) No Return of goods after 15 days of shipment.
                              <br />
                              2) Damaged goods must be returned within 10 days
                              of shipment.
                              <br />
                              3) No Returns will be accepted without RA #.
                              <br />
                              4) Returns without an advance shipping notice
                              (including tracking#) and an approved RA# will not
                              be processed.
                              <br />
                              5) A 5% deduction will be applied to any returned
                              unit that is missing the waist tag.
                              <br />
                              6) RA credits will not be issued for merchandise
                              that is worn, stained, or damaged.
                            </p>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            ) : footerData &&
              (footerData[0].term === "WIRE TRANSFER" ||
                footerData[0].term === "CONSIGNMENT" ||
                footerData[0].term === "PRE-PAYMENT" ||
                footerData[0].factor_id == 2) ? (
              <tfoot>
                <tr>
                  <td className="footer2_invoice external_invoice_footer">
                    <div className="sales-report-footer">
                      <div className="order_report_footer">
                        <div style={{ float: "left", fontSize: "14px" }}>
                          Due Date:{" "}
                          {footerData &&
                            moment(footerData[0].due_date).format("MM/DD/YYYY")}
                        </div>
                        <br />
                        <br />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Card style={{ width: "300px" }}>
                            <p
                              className="footer_order_p"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                textDecoration: "underline",
                              }}
                            >
                              Remit Payment To
                            </p>
                            <p className="footer_order_p">
                              US Customer Send Payment To:
                            </p>
                            <p className="footer_order_p">
                              DL1961 Premium Denim Inc.
                            </p>
                            <p className="footer_order_p">
                              121 Varick Street, 4th Floor
                            </p>
                            <p className="footer_order_p">
                              NEW YORK ,NY 10013, USA
                            </p>
                          </Card>

                          <Card style={{ width: "300px" }}>
                            <p
                              className="footer_order_p"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                textDecoration: "underline",
                              }}
                            >
                              Customer Wire Payment To:
                            </p>
                            <p className="footer_order_p">
                              JPMorgan Chase Bank,NA.
                            </p>
                            <p className="footer_order_p">
                              Address : 601 8thAve,New York,NY 10018
                            </p>
                            <p className="footer_order_p">
                              Phone : (212) 695-9164
                            </p>
                            <p className="footer_order_p">
                              Account Number : 218335361
                            </p>
                            <p className="footer_order_p">
                              Routing Number : 021000021
                            </p>
                            <p className="footer_order_p">
                              Swift Code : CHASUS33
                            </p>
                          </Card>

                          <Card style={{ width: "420px" }}>
                            <p
                              className="footer_order_p"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                textDecoration: "underline",
                              }}
                            >
                              Terms & Conditions
                            </p>
                            <p className="footer_order_p">
                              1) No Return of goods after 15 days of shipment.
                              <br />
                              2) Damaged goods must be returned within 10 days
                              of shipment.
                              <br />
                              3) No Returns will be accepted without RA #.
                              <br />
                              4) Returns without an advance shipping notice
                              (including tracking#) and an approved RA# will not
                              be processed.
                              <br />
                              5) A 5% deduction will be applied to any returned
                              unit that is missing the waist tag.
                              <br />
                              6) RA credits will not be issued for merchandise
                              that is worn, stained, or damaged.
                            </p>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            ) : footerData && footerData[0].factor_id == 1 ? (
              <tfoot>
                <tr>
                  <td className="footer2_invoice external_invoice_footer">
                    <div className="sales-report-footer">
                      <div className="order_report_footer">
                        <div style={{ float: "left", fontSize: "14px" }}>
                          Due Date:{" "}
                          {footerData &&
                            moment(footerData[0].due_date).format("MM/DD/YYYY")}
                        </div>
                        <br />
                        <br />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Card style={{ width: "463px" }}>
                            <p
                              className="footer_order_p"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              This Invoice has been sold or assigned to
                            </p>
                            <p
                              className="footer_order_p"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              THE CIT GROUP / COMMERCIAL SERVICES INC.
                            </p>
                            <p
                              className="footer_order_p"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              P.O BOX 1036 , CHARLOTTE,NC 28201-1036
                            </p>
                            <p
                              className="footer_order_p"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              to whom the account has been assigned solely for
                              collection
                            </p>
                            <p
                              className="footer_order_p"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              and to whom notice must be given of any
                              merchandise
                            </p>
                            <p
                              className="footer_order_p"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              returns or claims.Payment made to any other party
                              does
                            </p>
                            <p
                              className="footer_order_p"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              not constitute valid payment of this invoice.
                            </p>
                          </Card>

                          <Card style={{ width: "463px" }}>
                            <p
                              className="footer_order_p"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                textDecoration: "underline",
                              }}
                            >
                              Terms & Conditions
                            </p>
                            <p className="footer_order_p">
                              1) No Return of goods after 45 days of shipment.
                              <br />
                              2) Damaged goods must be returned within 10 days
                              of shipment.
                              <br />
                              3) No Returns will be accepted without RA#.
                              <br />
                              4) Payments must be received within due date.
                              <br />
                              5) All Overdue invoices will be charged @1.8% per
                              month.
                              <br />
                              6) No Return allowed on sale item.
                              <br />
                              7) Returns without an advance shipping notice
                              (including tracking#) and an approved RA# will not
                              be processed.
                              <br />
                              8) A 5% deduction will be applied to any returned
                              unit that is missing the waist tag.
                              <br />
                              9) RA credits will not be issued for merchandise
                              that is worn, stained, or damaged.
                            </p>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            ) : (
              <></>
            )} */}
          </table>
          {reportData.length > 0 && (
            <div
              className="no-print"
              style={{
                position: "fixed",
                top: "6%",
                right: "2%",
              }}
            >
              <Button type="primary" onClick={handlePrint}>
                Print
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ExternalInvoiceReport;
